import { Routes, Route, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import MainLayout from './components/layout/MainLayout';
import LandingPage from './pages/LandingPage';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';

export default function App() {
  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>DiSCX-US | Defense Industries Services &amp; Exchange</title>
        <meta name="description" content="DiSCX-US provides education on key warfighting and defense disciplines, led by Major General (Ret.) T. Glenn Davis." />
      </Helmet>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<LandingPage />} />
          <Route path="terms" element={<TermsOfService />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}
